import React, { useState } from 'react';
import styled from 'styled-components';
import { SocialBadge } from '../components/brand/Brand';
import SectionBg from '../components/SectionBg';

const infos = [
  { icon: 'ti-mail', label: 'Email', value: 'contact@tartina.fr' },
  { icon: 'ti-phone', label: 'Téléphone', value: '+237 6 00 00 00 00' },
  { icon: 'ti-map-pin', label: 'Adresse', value: 'Douala, Cameroun' },
];

const ContactPage = () => {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const set = (k, v) => setForm((p) => ({ ...p, [k]: v }));

  const submit = (e) => {
    e.preventDefault();
    // eslint-disable-next-line no-console
    console.log('Message de contact (maquette) :', form);
    setSent(true);
  };

  return (
    <>
      <Banner>
        <SectionBg tone="chocolate" variant={0} />
        <Inner>
          <Kicker>On t'écoute</Kicker>
          <h1>Nous contacter</h1>
          <p>Une question, une idée de recette, un partenariat ? Écris-nous, on adore échanger.</p>
        </Inner>
      </Banner>

      <Inner>
        <Layout>
          <Aside>
            {infos.map((i) => (
              <InfoItem key={i.label}>
                <InfoIcon><i className={`ti ${i.icon}`} aria-hidden="true" /></InfoIcon>
                <div>
                  <small>{i.label}</small>
                  <b>{i.value}</b>
                </div>
              </InfoItem>
            ))}
            <Socials>
              <SocialBadge />
              <IconRow>
                <a href="#" aria-label="Facebook"><i className="ti ti-brand-facebook" /></a>
                <a href="#" aria-label="Instagram"><i className="ti ti-brand-instagram" /></a>
                <a href="#" aria-label="TikTok"><i className="ti ti-brand-tiktok" /></a>
              </IconRow>
            </Socials>
          </Aside>

          <FormCard>
            {sent ? (
              <Success>
                <i className="ti ti-circle-check" aria-hidden="true" />
                <h2>Message envoyé !</h2>
                <p>Merci {form.name || ''}, on te répond très vite.</p>
                <Again type="button" onClick={() => { setSent(false); setForm({ name: '', email: '', message: '' }); }}>
                  Envoyer un autre message
                </Again>
              </Success>
            ) : (
              <form onSubmit={submit}>
                <Field>
                  <label>Nom</label>
                  <input value={form.name} onChange={(e) => set('name', e.target.value)} required />
                </Field>
                <Field>
                  <label>Email</label>
                  <input type="email" value={form.email} onChange={(e) => set('email', e.target.value)} required />
                </Field>
                <Field>
                  <label>Message</label>
                  <textarea rows="5" value={form.message} onChange={(e) => set('message', e.target.value)} required />
                </Field>
                <Send type="submit"><i className="ti ti-send" aria-hidden="true" /> Envoyer</Send>
              </form>
            )}
          </FormCard>
        </Layout>
      </Inner>
    </>
  );
};

const Banner = styled.section`
  background: ${({ theme }) => theme.colors.secondary}; padding: 40px 0 34px;
  position: relative; isolation: isolate;
  h1 { font-size: clamp(1.9rem, 4vw, 2.7rem); color: ${({ theme }) => theme.colors.chocolate}; margin: 6px 0 8px; }
  p { color: ${({ theme }) => theme.colors.chocolate}; opacity: 0.85; margin: 0; max-width: 56ch; }
`;
const Inner = styled.div`max-width: 1000px; margin: 0 auto; padding: 0 24px;`;
const Kicker = styled.span`
  display: block; color: ${({ theme }) => theme.colors.primary}; font-weight: 800; font-size: 0.85rem;
  text-transform: uppercase; letter-spacing: 1px;
`;
const Layout = styled.div`
  display: grid; grid-template-columns: 0.8fr 1.2fr; gap: 28px; margin: 32px 0 8px;
  @media (max-width: 760px) { grid-template-columns: 1fr; }
`;
const Aside = styled.div`display: flex; flex-direction: column; gap: 16px;`;
const InfoItem = styled.div`
  display: flex; align-items: center; gap: 14px;
  background: #fff; border: 1px solid ${({ theme }) => theme.colors.border}; border-radius: 16px; padding: 16px;
  small { display: block; color: ${({ theme }) => theme.colors.textSecondary}; font-size: 0.78rem; font-weight: 700; }
  b { color: ${({ theme }) => theme.colors.chocolate}; }
`;
const InfoIcon = styled.div`
  width: 44px; height: 44px; border-radius: 12px; flex: none;
  background: ${({ theme }) => theme.colors.cream}; display: flex; align-items: center; justify-content: center;
  i { font-size: 1.3rem; color: ${({ theme }) => theme.colors.primary}; }
`;
const Socials = styled.div`
  display: flex; flex-direction: column; gap: 12px; margin-top: 4px;
`;
const IconRow = styled.div`
  display: flex; gap: 10px;
  a {
    width: 42px; height: 42px; border-radius: 12px; background: ${({ theme }) => theme.colors.chocolate};
    color: #fff; display: inline-flex; align-items: center; justify-content: center; text-decoration: none;
    transition: background .15s ease; i { font-size: 1.2rem; }
    &:hover { background: ${({ theme }) => theme.colors.primary}; }
  }
`;
const FormCard = styled.div`
  background: #fff; border: 1px solid ${({ theme }) => theme.colors.border}; border-radius: 20px; padding: 26px;
`;
const Field = styled.div`
  display: flex; flex-direction: column; gap: 6px; margin-bottom: 16px;
  label { font-weight: 800; font-size: 0.85rem; color: ${({ theme }) => theme.colors.chocolate}; }
  input, textarea {
    font-family: inherit; font-size: 0.95rem; padding: 12px 14px; border-radius: 12px; outline: none;
    border: 1px solid ${({ theme }) => theme.colors.border}; background: ${({ theme }) => theme.colors.background};
    transition: border-color .15s ease, box-shadow .15s ease; resize: vertical;
  }
  input:focus, textarea:focus {
    border-color: ${({ theme }) => theme.colors.secondaryDark}; box-shadow: 0 0 0 3px rgba(255,221,0,0.25); background: #fff;
  }
`;
const Send = styled.button`
  display: inline-flex; align-items: center; gap: 8px; cursor: pointer; border: none; border-radius: 999px;
  padding: 13px 28px; font-weight: 800; font-size: 1rem; background: ${({ theme }) => theme.colors.primary}; color: #fff;
  transition: all .2s ease; &:hover { background: ${({ theme }) => theme.colors.primaryDark}; transform: translateY(-2px); }
`;
const Success = styled.div`
  text-align: center; padding: 24px 12px;
  i { font-size: 3rem; color: ${({ theme }) => theme.colors.success}; }
  h2 { margin: 12px 0 6px; color: ${({ theme }) => theme.colors.chocolate}; }
  p { color: ${({ theme }) => theme.colors.textSecondary}; margin: 0 0 18px; }
`;
const Again = styled.button`
  cursor: pointer; border: 2px solid ${({ theme }) => theme.colors.primary}; background: #fff;
  color: ${({ theme }) => theme.colors.primary}; font-weight: 800; padding: 10px 20px; border-radius: 999px;
`;

export default ContactPage;
